// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1_hol","cls2":"UserTooltip-cls2_QbR UserTooltip-cls1_hol"};